import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import { EnumHelper } from "@singularsystems/neo-core";
import UnauthorisedInvestmentCriteria from "./UnauthorisedInvestmentCriteria";
import { InvestmentType } from "./Investment.enum";

@NeoReport("UnauthorisedInvestment", { category: ReportCategory.CombinedReports })
export default class UnauthorisedInvestmentReport extends Report<UnauthorisedInvestmentCriteria> {

    constructor() {
        super(UnauthorisedInvestmentCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.FormGroupInline bind={this.criteria.meta.investmentType} select={{ items: EnumHelper.asList(InvestmentType) }} />
        </div>;
    }
}